import {
	type CacheConfig,
	Environment,
	type GraphQLSingularResponse,
	type IEnvironment,
	Network,
	type RequestParameters,
	type Variables,
} from 'relay-runtime';

import { getDefaultRelayEnvironmentConfig } from '@atlassian/relay-environment-config';
import { type AGGError, captureErrors, isUnauthenticated } from '@atlassian/relay-errors';
import { fetch } from '@atlassian/relay-fetch/multi-fetch';
import { SSRQueryResponseCache } from '@atlassian/relay-query-responses';
import { subscribe } from '@atlassian/relay-subscription';
const getLoggingAndMetricsHelper = () => {
	return {
		logNonBreakingErrors: () => {},
		logError: () => {},
		logErrorRetry: () => {},
		logQueryFallbackToPost: () => {},
	};
};

/**
 * @deprecated use useRelayEnvironment() from react-relay to get this environment instead of using it directly
 */
export const __INTERNAL_RELAY_ENVIRONMENT__DO_NOT_USE_THIS_DIRECTLY__: IEnvironment =
	new Environment(
		getDefaultRelayEnvironmentConfig({
			network: Network.create(
				(request: RequestParameters, variables: Variables, cacheConfig: CacheConfig) => {
					return fetch(request, variables, cacheConfig, {
						getLoggingAndMetricsHelper,
						withErrorHandling: (source: Promise<Response>) => source,
						validateResponse: (request: RequestParameters, response: GraphQLSingularResponse) => {
							const errors = 'errors' in response ? response.errors : undefined;
							if (errors != null) {
								const requestId = response?.extensions?.gateway?.request_id;

								captureErrors(errors as AGGError[], { operationName: request.name, requestId });

								if (isUnauthenticated(errors as AGGError[])) {
									return false;
								}
							}
							return true;
						},
						onInvalidResponse: () => {},
						queryResponseCache: new SSRQueryResponseCache({
							cacheName: 'relay-cache/v2/AGG',
							size: Infinity,
							ttl: Infinity,
						}),
						isServer: (globalThis as any).__SERVER__,
					});
				},
				subscribe,
			),
		}),
	);
